<template>
	<div>
		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
			border
			:pageModel="pageModel"
			:total="total"
			:fetchList="fetchUser"
			:clickData="clickData"
			@clickRight="clickRight"
		></x-table>
	</div>
</template>

<script type="text/javascript">
import { getAuditList, auditUser } from '@/api/group';
import { deepClone } from '@/utils/util';

export default {
	data() {
		return {
			pageModel: {
				page: 1,
				pageSize: 10
			},
			tableData: [],
			total: 0,
			tableHeaders: [
				{
					headerName: '学员昵称',
					headerKey: 'nickname',
					width: 100
				},
				{
					headerName: '学员ID',
					headerKey: 'uid',
					width: 100
				},
				{
					headerName: '加入时间',
					headerKey: 'CreatedAt',
					width: 200
				},
				{
					headerName: '上传图片',
					headerKey: 'audit_img',
					render: (h, { node }) => {
						const image = node.audit_img.split(',');
						return h(
							'span',
							image.map((i) =>
								h('img', {
									style: {
										width: '50px'
									},
									attrs: {
										src: i
									}
								})
							)
						);
					}
				},
				{
					headerName: '审核状态',
					headerKey: 'audit_state',
					width: 100,
					maps: {
						1: '未处理',
						2: '通过',
						3: '拒绝'
					}
				}
			],
			clickData: [
				{
					label: '通过',
					value: 'pass',
					rule(row) {
						return row.audit_state === 1;
					}
				},
				{
					label: '拒绝',
					value: 'refuse',
					rule(row) {
						return row.audit_state === 1;
					}
				}
			]
		};
	},
	props: {
		close: Function,
		fetchList: Function,
		detail: Object
	},
	watch: {
		detail: {
			handler(val) {
				if (!val) return;

				this.fetchUser();
			},
			immediate: true
		},
		canCoin() {}
	},
	methods: {
		fetchUser() {
			getAuditList({
				...this.pageModel,
				groupId: this.detail.id
			}).then((res) => {
				this.total = res.data.total;
				this.tableData = res.data.data;
			});
		},
		clickRight({ row, type }) {

			if (type === 'refuse') {
				this.$prompt('请输入拒绝理由', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValidator: value => {
						return !value ? '拒绝理由不能为空' : true
					}
				}).then(({ value }) => {
					auditUser({
						id: row.ID,
						state: 3,
						refuse_reason: value
					}).then((res) => {
						this.$message.success('操作成功');
						this.fetchUser();
					});
					
				})
					
			} else {
				this.$confirm('确认通过审核吗？', '提示').then((res) => {
					auditUser({
						id: row.ID,
						state: 2
					}).then((res) => {
						this.$message.success('操作成功');
						this.fetchUser();
					});
				});
			}
		}
	}
};
</script>

<style lang="less"></style>
